module.exports = __webpack_public_path__ + "static/media/GithubIcon.c6d08d9c.svg";